module.exports = __webpack_public_path__ + "img/ghc_logo_02-5.4e938e15.png";